const ipfs = (asset) => asset.image.replace('ipfs://', '');
export default ipfs;
